export function useCasinoProviderPage() {
  const { t } = useI18n()
  const route = useRoute()
  const providerCode = computed(() => String(route.params.provider))
  const casinoStore = useCasinoStore()
  const providerName = computed(
    () =>
      casinoStore.getCategoryByCode(providerCode.value)?.name ??
      providerCode.value ??
      '',
  )
  const pageTitle = computed(() =>
    t('pages.casino.providerGames', { provider: providerName.value }),
  )

  return { pageTitle, providerCode, providerName }
}
